import { ISearchFields } from 'types/searchFields';

export function searchTransportToMap({
    model,
    query,
    filters,
    sorts,
    pageNumber,
    pageSize,
}): Omit<ISearchFields, 'crm_id'> {
    return {
        term: query,
        entityType: model,
        pagination: {
            page: pageNumber,
            limit: pageSize,
        },
        filter: {
            ...filters,
            sort: sorts,
        },
    };
}

export function searchTransportFromMap(resp) {
    // TODO: Вероятно эти получаемые данные на бэке можно упросить
    const newListData = resp.data.data.map((elem) => {
        if (elem.data) {
            return {
                id: elem.id,
                type: elem.type,
                ...elem.data,
            };
        }
        return elem;
    });

    return newListData;
}

export function filtersOldToNew(oldFilters) {
    return {
        fromCreatedAt: oldFilters.createdDates[0] || null,
        toCreatedAt: oldFilters.createdDates[1] || null,
        fromUpdatedAt: oldFilters.updatedDates[0] || null,
        toUpdatedAt: oldFilters.updatedDates[1] || null,
        fromEventDate: oldFilters?.eventDates?.[0] || null,
        toEventDate: oldFilters?.eventDates?.[1] || null,
        // «Не показывать удалённые» в фильтрах хранится строкой 'null' — на бэк
        // уходит настоящий null, а не строка
        deleted_at: oldFilters.deleted === 'null' ? null : oldFilters.deleted,
        fromPrice: oldFilters?.price?.[0] || null,
        toPrice: oldFilters?.price?.[1] || null,
        type: oldFilters?.type,
        chapter: oldFilters?.chapter,
        status: oldFilters?.status,
        crm_id: oldFilters?.crm_id,
        is_other: oldFilters?.is_other || null,
    };
}

export function sortsOldToNew(oldFilters) {
    return {
        sort_by: oldFilters.sortBy,
        sort_dir: oldFilters.sortDirection,
    };
}
